var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#12425e",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16a3 3 0 0 0 3-3V3a3 3 0 0 0-6 0v10a3 3 0 0 0 3 3zM18.11 18.11a3.04 3.04 0 0 0 0-4.3L5.19.89a3.04 3.04 0 0 0-4.3 4.3l12.92 12.92a3.04 3.04 0 0 0 4.3 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    x: 4,
    y: 21,
    rx: 2.987
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.083 29.844l-9.24 9.24a2.88 2.88 0 0 0 4.074 4.072l9.24-9.24a2.88 2.88 0 1 0-4.074-4.072zM23.988 32a3 3 0 0 0-3 3v10a3 3 0 0 0 6 0V35a3 3 0 0 0-3-3zM33.958 29.885a2.88 2.88 0 0 0-4.073 4.073l5.157 5.157a2.88 2.88 0 0 0 4.073-4.073zM44.808 21h-9.616A3.097 3.097 0 0 0 32 23.992a3.097 3.097 0 0 0 3.192 2.993h9.616A3.097 3.097 0 0 0 48 23.992 3.097 3.097 0 0 0 44.808 21zM33.829 18.156l3.327-3.24a2.88 2.88 0 0 0-4.073-4.072l-3.24 3.24a2.88 2.88 0 0 0 0 4.072 2.775 2.775 0 0 0 3.986 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattles);
export default __webpack_public_path__ + "static/media/Battles.862c6239aae15775a9fdb79066cd8460.svg";
export { ForwardRef as ReactComponent };